import React from "react";

const Card = (props) => {
  return (
    <div
      className={[
        "rounded-xl w-full overflow-hidden grid grid-cols-1 gap-4 bg-white shadow-xl pb-4",
        props.center && "justify-items-center",
      ].join(" ")}
    >
      {props.children}
    </div>
  );
};

export default Card;
